import { Fragment } from 'react';
import { Link } from 'react-router-dom';

export const LOGIN_HEADER_PROPS = {
  title: 'Login to Siteplus',
};

export const INITIAL_VALUES = {
  email: '',
  password: '',
};

export const LOGIN_OPTIONS = [
  {
    value: 'user',
    label: 'As User',
  },
  {
    value: 'partner',
    label: 'As Partner',
  },
];
